import React, { FC, useContext, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import "./empowerAlertPopUp.scss";
import useIsMobileDimension from "../../hooks/useIsMobileDimension";
import { HEAP_EVENTS } from "@app/provider/types";
import {
  NotificationContext,
  OrderRenewalContext,
  UserContext,
} from "@app/provider";
import Dialog from "@natera/material/lib/dialog";
import Button from "@natera/material/lib/button";
import ResponceImage from "@assets/images/renewalPatientResponce.png";

const messages = defineMessages({
  empowerAlertPopUpTitle: {
    id: "empowerAlertPopUpTitle",
    defaultMessage:
      "Are you interested in learning more about hereditary cancer testing?",
  },
  empowerAlertPopUpAgreeButton: {
    id: "empowerAlertPopUpAgreeButton",
    defaultMessage: "Yes, I’d like to know if testing is right for me",
  },
  empowerAlertPopUpDisagreeButton: {
    id: "empowerAlertPopUpDisagreeButton",
    defaultMessage:
      "No, I am not interested in learning more about hereditary cancer testing",
  },
  empowerAlertPopUpGratitude: {
    id: "empowerAlertPopUpGratitude",
    defaultMessage: "Thanks for your response",
  },
});

interface EmpowerAlertPopUpProps {
  onCloseDialog: () => void;
  limsId?: number;
  orderUid?: string;
}

const EmpowerAlertPopUp: FC<EmpowerAlertPopUpProps> = ({
  onCloseDialog,
  limsId,
}) => {
  const intl = useIntl();
  const isMobile = useIsMobileDimension();
  const { uppUser } = useContext(UserContext);
  const { clear } = useContext(NotificationContext);
  const { handleSetPatientInterested } = useContext(OrderRenewalContext);

  const [activeDialog, setActiveDialog] = useState<"first" | "second" | null>(
    "first"
  );
  const [closingDialog, setClosingDialog] = useState<"first" | "second" | null>(
    null
  );
  const animationDuration = 600;

  React.useEffect(() => {
    if (isMobile && activeDialog) {
      const element = document.querySelector(`.popUp-dialog.mobile`);
      if (element) {
        element.classList.add("animate-up");
      }
    }
  }, [isMobile, activeDialog]);

  const handleCloseFirstDialog = () => {
    setClosingDialog("first");
    setTimeout(() => {
      setActiveDialog("second");
      setClosingDialog(null);
    }, animationDuration);
  };

  const handleCloseSecondDialog = () => {
    setClosingDialog("second");
    setTimeout(() => {
      clear();
      onCloseDialog();
    }, animationDuration);
  };

  const handleAgree = async () => {
    heap.track(HEAP_EVENTS.upp_empower_risk_yes_interested, {
      identity: uppUser?.patientUID,
      lims_clinic_id: limsId,
    });
    await handleSetPatientInterested(true);
    handleCloseFirstDialog();
  };

  const handleDisagree = async () => {
    heap.track(HEAP_EVENTS.upp_empower_risk_not_interested, {
      identity: uppUser?.patientUID,
      lims_clinic_id: limsId,
    });
    await handleSetPatientInterested(false);
    handleCloseFirstDialog();
  };

  return (
    <>
      {activeDialog === "first" && (
        <Dialog
          title={""}
          showCrossButton
          onClose={onCloseDialog}
          className={`popUp-dialog ${isMobile ? "mobile" : ""} ${
            closingDialog === "first" ? "animate-down" : ""
          }`}
        >
          <div className="popUp-dialog__content">
            <h3 className="popUp-dialog__content__header">
              {intl.formatMessage(messages.empowerAlertPopUpTitle)}
            </h3>
            <div className="popUp-dialog__content__button-container">
              <Button
                className="popUp-dialog__content__button"
                aria-label={intl.formatMessage(
                  messages.empowerAlertPopUpAgreeButton
                )}
                onClick={handleAgree}
                outlined
              >
                {intl.formatMessage(messages.empowerAlertPopUpAgreeButton)}
              </Button>
              <Button
                className="popUp-dialog__content__button"
                aria-label={intl.formatMessage(
                  messages.empowerAlertPopUpDisagreeButton
                )}
                onClick={handleDisagree}
                outlined
              >
                {intl.formatMessage(messages.empowerAlertPopUpDisagreeButton)}
              </Button>
            </div>
          </div>
        </Dialog>
      )}

      {activeDialog === "second" && (
        <Dialog
          title={""}
          showCrossButton
          onClose={handleCloseSecondDialog}
          className={`popUp-dialog ${isMobile ? "mobile" : ""} ${
            closingDialog === "second" ? "animate-down" : ""
          }`}
        >
          <div className="popUp-dialog__content">
            <img
              src={ResponceImage}
              alt={intl.formatMessage(messages.empowerAlertPopUpGratitude)}
            />
            <h3>{intl.formatMessage(messages.empowerAlertPopUpGratitude)}</h3>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default EmpowerAlertPopUp;
